import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-500 text-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2 mb-4 group">
              <span className="font-heading text-xl md:text-2xl font-bold text-background-50 tracking-tight">
                Pounce<span className="relative inline-flex items-center justify-center w-5 h-5 ml-0.5">
                  <i className="ri-footprint-fill text-accent-500 text-lg"></i>
                </span>Bounce
              </span>
            </Link>
            <p className="text-primary-200 text-sm leading-relaxed mb-5 max-w-xs">
              Premium, eco-friendly pet toys and accessories made from non-toxic, biodegradable materials — for dog and cat parents who treat their pets as family.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-600 text-background-50 hover:bg-accent-500 transition-colors duration-200" aria-label="Instagram">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-600 text-background-50 hover:bg-accent-500 transition-colors duration-200" aria-label="YouTube">
                <i className="ri-youtube-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-600 text-background-50 hover:bg-accent-500 transition-colors duration-200" aria-label="WhatsApp">
                <i className="ri-whatsapp-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">Shop</h4>
            <ul className="space-y-2.5">
              <li><Link to="/shop" className="text-primary-200 hover:text-background-50 text-sm transition-colors duration-200">All Products</Link></li>
              <li><Link to="/shop?pet=dog" className="text-primary-200 hover:text-background-50 text-sm transition-colors duration-200">For Dogs</Link></li>
              <li><Link to="/shop?pet=cat" className="text-primary-200 hover:text-background-50 text-sm transition-colors duration-200">For Cats</Link></li>
              <li><Link to="/shop?function=everyday-accessories" className="text-primary-200 hover:text-background-50 text-sm transition-colors duration-200">Accessories</Link></li>
              <li><Link to="/gifting" className="text-primary-200 hover:text-background-50 text-sm transition-colors duration-200">Gifting Edits</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">Company</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-primary-200 hover:text-background-50 text-sm transition-colors duration-200">About PounceBounce</Link></li>
              <li><Link to="/contact" className="text-primary-200 hover:text-background-50 text-sm transition-colors duration-200">Contact & FAQ</Link></li>
              <li><a href="https://wa.me/91XXXXXXXXXX" target="_blank" rel="noopener noreferrer" className="text-primary-200 hover:text-background-50 text-sm transition-colors duration-200 inline-flex items-center gap-1.5">
                <i className="ri-whatsapp-line text-sm"></i> Chat on WhatsApp
              </a></li>
            </ul>
          </div>

          {/* Trust badges */}
          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">We Stand For</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-primary-200 text-sm">
                <i className="ri-shield-check-line text-accent-500 text-sm"></i>
                Non-Toxic Materials
              </li>
              <li className="flex items-center gap-2 text-primary-200 text-sm">
                <i className="ri-leaf-line text-accent-500 text-sm"></i>
                Biodegradable & Eco-Friendly
              </li>
              <li className="flex items-center gap-2 text-primary-200 text-sm">
                <i className="ri-heart-pulse-line text-accent-500 text-sm"></i>
                Vet-Reviewed Safety
              </li>
              <li className="flex items-center gap-2 text-primary-200 text-sm">
                <i className="ri-flag-line text-accent-500 text-sm"></i>
                Made for Indian Pets
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-primary-400/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-primary-200 text-xs">
            &copy; {new Date().getFullYear()} PounceBounce. Play Hard. Tread Soft.
          </p>
          <div className="flex items-center gap-4 text-primary-200 text-xs">
            <a href="#" className="hover:text-background-50 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-background-50 transition-colors">Terms of Service</a>
            <span className="flex items-center gap-1">
              <i className="ri-whatsapp-fill text-[#25D366]"></i> Order via WhatsApp
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}